import { render } from "./PubmedView.vue?vue&type=template&id=72e87c0a&scoped=true"
import script from "./PubmedView.vue?vue&type=script&lang=js"
export * from "./PubmedView.vue?vue&type=script&lang=js"

import "./PubmedView.vue?vue&type=style&index=0&id=72e87c0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72e87c0a"]])

export default __exports__